import src from "IMAGE";
export default { src, width: 300, height: 114, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAS0lEQVR42i3GMQqAMAxA0Z4jAQsSXNUhiwhZPYJIryE4SQfx3P1Dh8f/SVUnDL0jMg6UiMiJ+XDjR8XT+5pZTSJy4kLBjgUbVnefG+9cD9AzH2UpAAAAAElFTkSuQmCC"};
